<div class="col-xs-12">
  <div class="content">
    <span class="icon cliente-nao-elegivel content-icon"></span>
    <h3>Ops.. Cliente não elegível a crédito</h3>
    <span>No momento não existe nenhuma condição especial<br>
          de financiamento para esse perfil de cliente.</span>

    <a (click)="finalizar()" class=" btn btn-border-orange">Finalizar</a>
  </div>
</div>
